import { selector, selectorFamily } from "recoil"
import { usersInEntityState, usersPerSiteState, snapshotUsersInEntityState } from "../store/users.store"
import { FolderNode, UserPerSite } from "../../api-client-nswag/custompermission-client"
import { folderTreeState } from "../store/folderTree.store"

export const usersInEntitySelector = selector<UserPerSite[]>({
  key: "usersInEntity/selector",
  get: ({ get }) => get(usersInEntityState),
})

export const usersPerSiteSelector = selector<UserPerSite[]>({
  key: "usersPerSite/selector",
  get: ({ get }) => get(usersPerSiteState),
})


export const usersNotInEntityByFolderSelector = selectorFamily<UserPerSite[], number | null>({
  key: "usersPerSite/notInEntityByFolderSelector",
  get: (parentFolderId) => ({ get }) => {
    const usersPerSite = get(usersPerSiteState);
    const usersInEntity = get(usersInEntityState);
    const folderTree = get(folderTreeState);

    const inEntityIds = new Set(usersInEntity.map(u => String(u.userId)));

    if (!parentFolderId) {
      return usersPerSite.filter(u => !inEntityIds.has(String(u.userId)));
    }

    const folder = findFolderById(folderTree, parentFolderId);
    if (!folder) {
      return usersPerSite.filter(u => !inEntityIds.has(String(u.userId)));
    }

    const folderUserIds = new Set(folder.users.map(String));

    return usersPerSite.filter(
      u =>
        folderUserIds.has(String(u.userId)) &&
        !inEntityIds.has(String(u.userId))
    );
  },
});

export const isUserListDirtySelector = selector<boolean>({
  key: "usersInEntity/dirtySelector",
  get: ({ get }) => {
    const current = get(usersInEntityState)
    const snapshot = get(snapshotUsersInEntityState)

    if (current.length !== snapshot.length) return true

    const snapshotIds = new Set(snapshot.map(u => u.userId))
    return current.some(u => !snapshotIds.has(u.userId))
  },
})

const findFolderById = (tree: FolderNode[], folderId: number | null): FolderNode | null => {
  if (folderId === null) return null;

  const stack = [...tree];
  while (stack.length > 0) {
    const node = stack.pop()!;
    if (node.folderId === folderId) return node;
    if (node.children?.length) stack.push(...node.children);
  }
  return null;
};